import { CreateBase, Form, useGetIdentity } from "ra-core";
import { Breadcrumb } from "@/components/admin";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router";

import type { Contact } from "../types";
import { ContactInputs } from "./ContactInputs";
import { FormToolbar } from "../layout/FormToolbar";

export const ContactCreate = () => {
  const { identity } = useGetIdentity();
  return (
    <CreateBase
      redirect="show"
      transform={(data: Contact) => ({
        ...data,
        first_seen: new Date().toISOString(),
        last_seen: new Date().toISOString(),
        tags: [],
      })}
    >
      <div className="mt-2 flex flex-col gap-4 max-w-4xl mx-auto w-full pb-10 px-4">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/contacts">Leads</Link></Breadcrumb.Item>
          <Breadcrumb.PageItem>Create</Breadcrumb.PageItem>
        </Breadcrumb>

        {/* Header Title */}
        <div className="flex flex-col gap-1.5 mb-2">
          <h1 className="text-2xl font-bold text-foreground dark:text-slate-100">Create Lead</h1>
          <p className="text-sm text-muted-foreground">Add a new contact to your lead pipeline.</p>
        </div>

        {/* Centered Form Card */}
        <div className="w-full">
          <Form defaultValues={{ sales_id: identity?.id }}>
            <Card className="shadow-md border border-border/80">
              <CardContent className="pt-6">
                <ContactInputs />
                <div className="mt-6 pt-4 border-t border-border/80">
                  <FormToolbar />
                </div>
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
